import * as React from 'react';

import {Divider} from 'shells/layout/divider';

import {KeyboardShortcuts} from './keyboard-shortcuts';

import styles from './search-bar-popover.module.css';

export const Footer = () => {
    return (
        <>
            <div className={styles['footer-divider']}>
                <Divider variant='line--horizontal' />
            </div>
            <div className={styles['footer-container']}>
                <KeyboardShortcuts />
            </div>
        </>
    );
};
